<template>
  <div id="app">
    <nav>
      <main-nav-bar></main-nav-bar>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"/>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"/> 
      <main-footer></main-footer>
    </nav>
  </div>
</template>

<script>
import MainNavBar from './components/navbar/MainNavBar.vue'
import MainFooter from './components/footer/MainFooter.vue'


export default{
  components: { MainNavBar, MainFooter},
}
</script>


<style>


</style>
